/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PatchedRealtyGroup,
    PatchedRealtyGroupFromJSON,
    PatchedRealtyGroupToJSON,
    PatchedRealtyGroupEstimation,
    PatchedRealtyGroupEstimationFromJSON,
    PatchedRealtyGroupEstimationToJSON,
    RealtyGroup,
    RealtyGroupFromJSON,
    RealtyGroupToJSON,
    RealtyGroupDetail,
    RealtyGroupDetailFromJSON,
    RealtyGroupDetailToJSON,
    RealtyGroupEstimation,
    RealtyGroupEstimationFromJSON,
    RealtyGroupEstimationToJSON,
} from '../models';

export interface CreateRealtyGroupRequest {
    realtyGroup: RealtyGroup;
}

export interface CreateRealtyGroupEstimationRequest {
    realtyGroupId: string;
    realtyGroupEstimation: RealtyGroupEstimation;
}

export interface GetRealtyGroupRequest {
    id: number;
}

export interface ListRealtyGroupRequest {
    search?: string;
}

export interface PartialUpdateRealtyGroupRequest {
    id: number;
    patchedRealtyGroup?: PatchedRealtyGroup;
}

export interface PartialUpdateRealtyGroupEstimationRequest {
    id: number;
    realtyGroupId: string;
    patchedRealtyGroupEstimation?: PatchedRealtyGroupEstimation;
}

export interface UpdateRealtyGroupRequest {
    id: number;
    realtyGroup: RealtyGroup;
}

export interface UpdateRealtyGroupEstimationRequest {
    id: number;
    realtyGroupId: string;
    realtyGroupEstimation: RealtyGroupEstimation;
}

/**
 * RealtyGroupApi - interface
 * 
 * @export
 * @interface RealtyGroupApiInterface
 */
export interface RealtyGroupApiInterface {
    /**
     * 
     * @param {RealtyGroup} realtyGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    createRealtyGroupRaw(requestParameters: CreateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>>;

    /**
     */
    createRealtyGroup(requestParameters: CreateRealtyGroupRequest): Promise<RealtyGroup>;

    /**
     * 
     * @param {string} realtyGroupId 
     * @param {RealtyGroupEstimation} realtyGroupEstimation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    createRealtyGroupEstimationRaw(requestParameters: CreateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>>;

    /**
     */
    createRealtyGroupEstimation(requestParameters: CreateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation>;

    /**
     * 
     * @param {number} id A unique integer value identifying this group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    getRealtyGroupRaw(requestParameters: GetRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroupDetail>>;

    /**
     */
    getRealtyGroup(requestParameters: GetRealtyGroupRequest): Promise<RealtyGroupDetail>;

    /**
     * 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    listRealtyGroupRaw(requestParameters: ListRealtyGroupRequest): Promise<runtime.ApiResponse<Array<RealtyGroup>>>;

    /**
     */
    listRealtyGroup(requestParameters: ListRealtyGroupRequest): Promise<Array<RealtyGroup>>;

    /**
     * 
     * @param {number} id A unique integer value identifying this group.
     * @param {PatchedRealtyGroup} [patchedRealtyGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    partialUpdateRealtyGroupRaw(requestParameters: PartialUpdateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>>;

    /**
     */
    partialUpdateRealtyGroup(requestParameters: PartialUpdateRealtyGroupRequest): Promise<RealtyGroup>;

    /**
     * 
     * @param {number} id A unique integer value identifying this group estimation.
     * @param {string} realtyGroupId 
     * @param {PatchedRealtyGroupEstimation} [patchedRealtyGroupEstimation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    partialUpdateRealtyGroupEstimationRaw(requestParameters: PartialUpdateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>>;

    /**
     */
    partialUpdateRealtyGroupEstimation(requestParameters: PartialUpdateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation>;

    /**
     * 
     * @param {number} id A unique integer value identifying this group.
     * @param {RealtyGroup} realtyGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    updateRealtyGroupRaw(requestParameters: UpdateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>>;

    /**
     */
    updateRealtyGroup(requestParameters: UpdateRealtyGroupRequest): Promise<RealtyGroup>;

    /**
     * 
     * @param {number} id A unique integer value identifying this group estimation.
     * @param {string} realtyGroupId 
     * @param {RealtyGroupEstimation} realtyGroupEstimation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RealtyGroupApiInterface
     */
    updateRealtyGroupEstimationRaw(requestParameters: UpdateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>>;

    /**
     */
    updateRealtyGroupEstimation(requestParameters: UpdateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation>;

}

/**
 * 
 */
export class RealtyGroupApi extends runtime.BaseAPI implements RealtyGroupApiInterface {

    /**
     */
    async createRealtyGroupRaw(requestParameters: CreateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>> {
        if (requestParameters.realtyGroup === null || requestParameters.realtyGroup === undefined) {
            throw new runtime.RequiredError('realtyGroup','Required parameter requestParameters.realtyGroup was null or undefined when calling createRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RealtyGroupToJSON(requestParameters.realtyGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupFromJSON(jsonValue));
    }

    /**
     */
    async createRealtyGroup(requestParameters: CreateRealtyGroupRequest): Promise<RealtyGroup> {
        const response = await this.createRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async createRealtyGroupEstimationRaw(requestParameters: CreateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>> {
        if (requestParameters.realtyGroupId === null || requestParameters.realtyGroupId === undefined) {
            throw new runtime.RequiredError('realtyGroupId','Required parameter requestParameters.realtyGroupId was null or undefined when calling createRealtyGroupEstimation.');
        }

        if (requestParameters.realtyGroupEstimation === null || requestParameters.realtyGroupEstimation === undefined) {
            throw new runtime.RequiredError('realtyGroupEstimation','Required parameter requestParameters.realtyGroupEstimation was null or undefined when calling createRealtyGroupEstimation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{realtyGroupId}/estimations/`.replace(`{${"realtyGroupId"}}`, encodeURIComponent(String(requestParameters.realtyGroupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RealtyGroupEstimationToJSON(requestParameters.realtyGroupEstimation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupEstimationFromJSON(jsonValue));
    }

    /**
     */
    async createRealtyGroupEstimation(requestParameters: CreateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation> {
        const response = await this.createRealtyGroupEstimationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async getRealtyGroupRaw(requestParameters: GetRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroupDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupDetailFromJSON(jsonValue));
    }

    /**
     */
    async getRealtyGroup(requestParameters: GetRealtyGroupRequest): Promise<RealtyGroupDetail> {
        const response = await this.getRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listRealtyGroupRaw(requestParameters: ListRealtyGroupRequest): Promise<runtime.ApiResponse<Array<RealtyGroup>>> {
        const queryParameters: any = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RealtyGroupFromJSON));
    }

    /**
     */
    async listRealtyGroup(requestParameters: ListRealtyGroupRequest): Promise<Array<RealtyGroup>> {
        const response = await this.listRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateRealtyGroupRaw(requestParameters: PartialUpdateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedRealtyGroupToJSON(requestParameters.patchedRealtyGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateRealtyGroup(requestParameters: PartialUpdateRealtyGroupRequest): Promise<RealtyGroup> {
        const response = await this.partialUpdateRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async partialUpdateRealtyGroupEstimationRaw(requestParameters: PartialUpdateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling partialUpdateRealtyGroupEstimation.');
        }

        if (requestParameters.realtyGroupId === null || requestParameters.realtyGroupId === undefined) {
            throw new runtime.RequiredError('realtyGroupId','Required parameter requestParameters.realtyGroupId was null or undefined when calling partialUpdateRealtyGroupEstimation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{realtyGroupId}/estimations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"realtyGroupId"}}`, encodeURIComponent(String(requestParameters.realtyGroupId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedRealtyGroupEstimationToJSON(requestParameters.patchedRealtyGroupEstimation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupEstimationFromJSON(jsonValue));
    }

    /**
     */
    async partialUpdateRealtyGroupEstimation(requestParameters: PartialUpdateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation> {
        const response = await this.partialUpdateRealtyGroupEstimationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateRealtyGroupRaw(requestParameters: UpdateRealtyGroupRequest): Promise<runtime.ApiResponse<RealtyGroup>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRealtyGroup.');
        }

        if (requestParameters.realtyGroup === null || requestParameters.realtyGroup === undefined) {
            throw new runtime.RequiredError('realtyGroup','Required parameter requestParameters.realtyGroup was null or undefined when calling updateRealtyGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RealtyGroupToJSON(requestParameters.realtyGroup),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupFromJSON(jsonValue));
    }

    /**
     */
    async updateRealtyGroup(requestParameters: UpdateRealtyGroupRequest): Promise<RealtyGroup> {
        const response = await this.updateRealtyGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async updateRealtyGroupEstimationRaw(requestParameters: UpdateRealtyGroupEstimationRequest): Promise<runtime.ApiResponse<RealtyGroupEstimation>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRealtyGroupEstimation.');
        }

        if (requestParameters.realtyGroupId === null || requestParameters.realtyGroupId === undefined) {
            throw new runtime.RequiredError('realtyGroupId','Required parameter requestParameters.realtyGroupId was null or undefined when calling updateRealtyGroupEstimation.');
        }

        if (requestParameters.realtyGroupEstimation === null || requestParameters.realtyGroupEstimation === undefined) {
            throw new runtime.RequiredError('realtyGroupEstimation','Required parameter requestParameters.realtyGroupEstimation was null or undefined when calling updateRealtyGroupEstimation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/realty-group/{realtyGroupId}/estimations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"realtyGroupId"}}`, encodeURIComponent(String(requestParameters.realtyGroupId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RealtyGroupEstimationToJSON(requestParameters.realtyGroupEstimation),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RealtyGroupEstimationFromJSON(jsonValue));
    }

    /**
     */
    async updateRealtyGroupEstimation(requestParameters: UpdateRealtyGroupEstimationRequest): Promise<RealtyGroupEstimation> {
        const response = await this.updateRealtyGroupEstimationRaw(requestParameters);
        return await response.value();
    }

}
